module.exports = __webpack_public_path__ + "img/asset.e724ccb4.svg";